<template>
  <div v-if="edit">
    <div class="vertical-center" style="margin-bottom: 10px;">
      <div class="space-r-2">
        {{ "お子様" + count }}
      </div>
      <div class="select space-r-1">
        <select
          class="form-control inline child_sex"
          :value="selectedSex"
          @change="changeSex"
        >
          <option></option>
          <option
            v-for="sex in child_sex"
            :value="sex.code"
            :key="`child-${sex.code}`"
          >{{ sex.value }}</option>
        </select>
      </div>
      <div class="select space-r-1">
        <select
          class="form-control inline child_year"
          :value="selectedYear"
          @change="changeYear"
        >
          <option></option>
          <option
            v-for="year in birthdayYears"
            :value="year"
            :key="`child-${year}`"
          >{{ year }}</option>
        </select>
      </div>
      <div class="select space-r-1">
        <select
          class="form-control inline child_month"
          :value="selectedMonth"
          @change="changeMonth"
        >
          <option></option>
          <option
            v-for="m in 12"
            :value="m"
            :key="`child-${m}`"
          >{{ getMonth(m) }}</option>
        </select>
      </div>
    </div>
  </div>
  <div v-else>
    <table>
      <tr v-if="getChildSex() !== ''">
        <td class="child-label">{{ "お子様" + count }}</td>
        <td class="child-sex"> {{ getChildSex() }} </td>
        <td class="child-year"> {{ getChildYear() }} </td>
        <td>{{ (getChildYear() || getChildMonth()) ? "/" : ""}}</td>
        <td class="child-month"> {{ getChildMonth() }} </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { getChildBirthdayYears } from '@/utils/form'

export default {
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: () => false
    },
    count: {
      type: Number,
      required: true
    },
    child: {
      type: Object,
      required: true
    },
    update: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      selectedSex: this.child.sex,
      selectedYear: this.child.year,
      selectedMonth: this.child.month,
      childKey: `child${this.count}`,
      child_sex: [
        {code: 1, value: '無回答'},
        {code: 2, value: '男の子'},
        {code: 3, value: '女の子'}
      ]
    }
  },
  methods: {
    getChildSex() {
      var sex = this.selectedSex
      var finded = this.child_sex.find(function(val){
        return val.code == sex
      }, sex)
      return finded ? finded.value : ''
    },
    getChildYear() {
      return this.selectedYear && this.selectedYear > 0 ? this.selectedYear : ""
    },
    getChildMonth() {
      return this.selectedMonth && this.selectedMonth > 0 ? this.getMonth(this.selectedMonth) : ""
    },
    getMonth(mon) {
      return ("0"+mon).slice(-2)
    },
    changeSex(event) {
      if (!event.target.value && this.selectedSex) {
        this.selectedYear = event.target.value
        this.selectedMonth = event.target.value
      }
      this.selectedSex = event.target.value
      this.updateChild()
    },
    changeYear(event) {
      if (!event.target.value && this.selectedYear) {
        this.selectedSex = event.target.value
        this.selectedMonth = event.target.value
      }
      this.selectedYear = event.target.value
      this.updateChild()
    },
    changeMonth(event) {
      if (!event.target.value && this.selectedMonth) {
        this.selectedSex = event.target.value
        this.selectedYear = event.target.value
      }
      this.selectedMonth = event.target.value
      this.updateChild()
    },
    updateChild() {
      this.update({
        idx: this.count - 1,
        key: this.childKey,
        sex: this.selectedSex,
        year: this.selectedYear,
        month: this.selectedMonth }
      )
    }
  },
  created() {
    this.birthdayYears = getChildBirthdayYears()
  }
}
</script>

<style scoped>
.child-label {
  width: 80px;
  padding: 0 5px;
  text-align: left
}
.child-sex {
  width: 60px;
  padding: 0 5px;
  text-align: left
}
.child-year {
  width: 50px;
  padding: 0 5px;
  text-align: right
}
.child-month {
  width: 30px;
  padding: 0 5px;
  text-align: left
}
</style>
